import React, { ReactElement } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, makeStyles } from '@material-ui/core';
import { Button } from '@payactive/app-common';
import { useTranslation } from 'react-i18next';

interface Props {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const useStyles = makeStyles((theme) => ({
  backDrop: {
    backdropFilter: 'blur(30px)',
    backgroundColor: 'rgba(0,0,30,0.4)',
  },
  button: {
    backgroundColor: theme.palette.error.main,
  },
}));

export default function SubscriptionCancelDialog({ open, onClose, onDelete }: Props): ReactElement {
  const { t } = useTranslation('payments');
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          return false;
        }
        onClose();
      }}
      BackdropProps={{
        classes: {
          root: classes.backDrop,
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">{t('cancel subscriptions')}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText id="alert-dialog-description">{t('cancel subscriptions text')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="text" name="cancel" label={t('global:back')} onClick={onClose} />
        <Button className={classes.button} name="delete" variant="contained" label={t('kündigen')} onClick={onDelete} />
      </DialogActions>
    </Dialog>
  );
}
